<template>
  <div class="">
    <BusinessBody />
  </div>
</template>
<script>
import BusinessBody from "./components/BusinessBody";
export default {
  components: {
    BusinessBody,
  },
};
</script>
